import { actionLimitApi } from '@/app/axios';
import session from '@/app/providers/session';

export type ActionLimitResponse = {
  classification: string;
  message: string;
  data: boolean;
};

export async function checkQrPaymentActionLimit(legalPartyId: number) {
  const deviceIdHeaders = session.applyDeviceIdHeaders();
  const response = await actionLimitApi().get<ActionLimitResponse>(`ob-front/${legalPartyId}/qr-payment`, {
    headers: { ...deviceIdHeaders },
  });
  return response?.data;
}

export async function checkInvoiceActionLimit(legalPartyId: number) {
  const deviceIdHeaders = session.applyDeviceIdHeaders();
  const response = await actionLimitApi().get<ActionLimitResponse>(`ob-front/${legalPartyId}/invoice`, {
    headers: { ...deviceIdHeaders },
  });
  return response?.data;
}

export async function checkPaymentActionLimit(legalPartyId: number, elementId: 'savePayment' | 'updatePayment') {
  const deviceIdHeaders = session.applyDeviceIdHeaders();

  const response = await actionLimitApi().get<ActionLimitResponse>(`ob-front/${legalPartyId}/${elementId}`, {
    headers: { ...deviceIdHeaders },
  });
  return response.data;
}
